import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-5 py-24 text-center">
      <XCircle className="h-12 w-12 text-ink-muted mx-auto" />
      <h1 className="font-heading text-3xl text-ink mt-6">Paiement annulé</h1>
      <p className="text-ink-muted mt-2">Votre commande n'a pas été finalisée et aucun montant n'a été débité.</p>
      <Button asChild className="mt-6 bg-terracotta hover:bg-terracotta-dark text-white rounded-md"><Link to="/panier">Revenir au panier</Link></Button>
    </div>
  );
}
